"use client";

import { BSRStar } from "./bsr/BSRStar";
import { createBSRExperimentIcon } from "./createBSRExperimentIcon";
import { StarOutlined as LegacyStarOutlined } from "./legacy/StarOutlined";

export const StarOutlined = createBSRExperimentIcon(
  LegacyStarOutlined,
  BSRStar
);
